import React, { Component } from "react"
import { connect } from 'react-redux';
import moment from 'moment'
import { DatePicker, Input } from "../core";
import Checkbox from "@material-ui/core/Checkbox";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import {DropDownMuti } from '../../components/core';
import {
    data_status
 } from '../../configs/datas'

import { Storage } from "../../configs";
import { updateStatusAction, getMyTaskAction } from '../../redux/actions/MyTaskAction';
import {ACollapse,TableCommittee} from "../../components"
import { BorderStyle } from "@material-ui/icons";
var base64 = require('base-64');
var utf8 = require('utf8');

class TaskTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filter_status_name: '',
            filter_mom_no: '',
            filter_doc_no: '',
            filter_po_contract_no: '',
            filter_po_header_text: '',
            filter_create_po_contract_emp_name: '',
            filter_saveBy: '',
            filter_editBy: '',
            filter_updatedate: '',
            taskArr:[],
            inprogressUpdateStatus:[],
            isShowButtonUpdateStatus: false,
            page:0,
            rowsPerPage: 10,
            MUTI_STATUSList:[],
          };
          

         this.handlerEditClick=this.handlerEditClick.bind(this);
         this.handleChange = this.handleChange.bind(this);
         this.handlerClearFilterClick=this.handlerClearFilterClick.bind(this);
         this.initState = this.initState.bind(this);
         this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
         this.handleDropdownMutiChange = this.handleDropdownMutiChange.bind(this);
    }

    getStatus(status_code) {
        const result = data_status.filter((data) => {
            return data.code === status_code
        })
        return result[0] ? result[0].description : ""
    }

    statusOptions = () => {
        return Promise.resolve([
            {
            value: "DRAF",	
            label: "Draft"
            },
            {
            value: "WVER",	
            label: "Waiting for Verification"
            },
            {
            value: "VERI",	
            label: "Verifying"
            },
            {
            value: "REJT",	
            label: "Rejected"
            },
            {
            value: "BCFM",	
            label: "Automatically process"
            },
            {
            value: "MCFM",	
            label: "Manually process"
            },
            {
            value: "MCOM",	
            label: "Manual Completed"
            },
            {
            value: "BPRO",	
            label: "BOT Processing"
            },
            {
            value: "BCOM",	
            label: "BOT Completed"
            },
            {
            value: "BPCO",	
            label: "BOT Partial Completed"
            },
            {
            value: "BINC",	
            label: "BOT Incomplete"
            },
            // {
            // value: "DELE",	
            // label: "Delete"
            // },
            {
            value: "WACCEPT",	
            label: "Waiting for Accept"
            },
            {
            value: "ACCEPT",	
            label: "Accept"
            },
            {
            value: "DECL",	
            label: "Decline"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            }
        ]);
    }


    handlerEditClick(rowIndex, transactionNo,doc_type) {

        //console.log(rowIndex)
        //console.log(transaction_no)
        
        var text = 'foo © bar 𝌆 baz';
        var bytes = utf8.encode(text);
        var encoded = base64.encode(bytes);

        console.log('base64')
        console.log(encoded);

        var bytes = base64.decode(encoded);
        var text = utf8.decode(bytes);
        console.log(text);

        let { history, tasks } = this.props;

        if (transactionNo !== '') {
            var clickRowOntask = tasks.filter((data) => {
                return data.transaction_no && data.transaction_no === transactionNo
            })

            if (clickRowOntask.length > 0) {

                let bytes_tran_no = utf8.encode(clickRowOntask[0].transaction_no);
                let encoded_transaction_no = base64.encode(bytes_tran_no);

                let bytes_po_contract_no = utf8.encode(clickRowOntask[0].po_contract_no);
                let encoded_po_contract_no = base64.encode(bytes_po_contract_no);
                if (doc_type == "BOT"){
                    history.push({
                        pathname: '/main',
                        search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                        state: { tasks: clickRowOntask[0], mode: 'EDIT' }
                    });
                }else{
                    history.push({
                        pathname: '/mainnotbot',
                        search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                        state: { tasks: clickRowOntask[0], mode: 'EDIT' }
                    });
                
                }
            }
        }
    }

    handlerClearFilterClick() {
        
        this.initState()
         this.setState({ taskArr: this.props.tasks })
    }

    initState()
    {
        this.setState({filter_status_name: '',
            filter_mom_no : '',
            filter_doc_no: '',
            filter_po_contract_no: '',
            filter_po_header_text: '',
            filter_create_po_contract_emp_name: '',
            filter_saveBy: '',
            filter_editBy: '',
            filter_updatedate: '',
            MUTI_STATUSList:[],
            taskArr:[]})
    }

    renderCheckbox(type) {
        const role = Storage.getRole()
        return (
            
            type === 'head' ? (
               
                role === 'R' ? (
                    <TableCell style={{ width: '80px', maxWidth:'80px' }}>
                        <div className="th-text text-center">Mark<br />Complete</div>
                    </TableCell>
                ) : null

            ) : null
        );
    }

    renderfilter() {
        const role = Storage.getRole()
        return (
            role === 'R' ? (
                <TableCell></TableCell>
            ) : null
        );
    }

    async handleChange(event) {

        function rowFilter(dataColumn,filter,Type){
            if(Type==="TypeDate")
                dataColumn=moment(dataColumn).format('DD/MM/YYYY')
            
            if(filter === ' ')
            return dataColumn === null || dataColumn === ''
            else
            return dataColumn &&  dataColumn.toLowerCase().indexOf(filter.toLowerCase()) > -1
        }

        event.preventDefault()
        const { name, value } = event.target;

        //console.log(name + ":" + value)
        await this.setState({ [name]: value })
        let searchtask = []
        searchtask = this.props.tasks

        if (this.state.filter_status_name !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.status_name,this.state.filter_status_name)
            })
        }
        if (this.state.filter_mom_no !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.mom_no,this.state.filter_mom_no)
            })
        }
        if (this.state.filter_doc_no !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.doc_no,this.state.filter_doc_no)
            })
        }
        if (this.state.filter_po_contract_no !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.po_contract_no,this.state.filter_po_contract_no)
            })
        }
        if (this.state.filter_po_header_text !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.po_header_text,this.state.filter_po_header_text)
            })
        }
        if (this.state.filter_create_po_contract_emp_name !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.create_po_contract_emp_name!==" "?data.create_po_contract_emp_name:"",this.state.filter_create_po_contract_emp_name)
            })
        }
        if (this.state.filter_saveBy !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.createBy_name,this.state.filter_saveBy)
            })
        }
        if (this.state.filter_editBy !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.reviewer_name,this.state.filter_editBy)
            })
        }
        if (this.state.filter_updatedate !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.updatedate,this.state.filter_updatedate,"TypeDate")
            })
        }

        //this.props.onfilter(!searchtask ? 0 : searchtask.length)
        await this.setState({ taskArr: searchtask, page: 0 })

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tasks !== this.state.taskArr) {

            this.setState({
                taskArr: nextProps.tasks
            })
            //this.props.onfilter(!nextProps.tasks ? 0 : nextProps.tasks.length)
            
        }
       
    }

    async handleDropdownMutiChange(event) {
        function rowFilter(dataColumn,filter,Type){
            if(Type==="TypeDate")
                dataColumn=moment(dataColumn).format('DD/MM/YYYY')
            
            if(filter === ' ')
            return dataColumn === null || dataColumn === ''
            else
            return dataColumn &&  dataColumn.toLowerCase().indexOf(filter.toLowerCase()) > -1
        }

       // event.preventDefault()
      //  const { name } = event.target;
        let searchtask = []
        searchtask = this.props.tasks
        let value=null
        if(event)
        {
            const target = event.target
            value = event
        }
        console.log("event =>" , value)
        await this.setState({
            ["MUTI_STATUSList"]: value      
        })

        if (event) {
        searchtask = searchtask.filter((el) => {
            return value.some((f) => {
              return f.value === el.status;
            });
          });
        }
        await this.setState({ taskArr: searchtask, page: 0 })
    }


    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }
    
    renderCheckboxMC(status, statusName, transaction_no) {
       
        const role = Storage.getRole()
        if (role == 'R') {
            return (
                status === 'BPCO' || status == "BINC" || status === 'MCFM' || status === 'MCOM' || status === 'BCOM' ? (
                    status === 'MCOM' || status === 'BCOM' ? (
                        <TableCell style={{ textAlign: 'center' }}>
                            <Checkbox
                                checked={status === 'MCOM' || status === 'BCOM' ? true : false}
                                color="primary"
                                style={{paddingTop:0,color:"rgba(172, 168, 168, 0.26)"}}
                                disabled={true}
                                name={transaction_no}
                                id={transaction_no}
                            />
                        </TableCell>
                    ) : (
                            <TableCell style={{ textAlign: 'center' }}>
                                <Checkbox
                                    color="primary"
                                    style={{paddingTop:0}}
                                    disabled={false}
                                    name={transaction_no}
                                    id={transaction_no}
                                    onClick={(event) => this.handleChangeCheckbox(event, status, transaction_no)}
                                />
                            </TableCell>
                        )
                ) : (
                        <TableCell style={{ textAlign: 'center' }}>
                            <Checkbox
                                inputProps={{ "aria-labelledby": '' }}
                                color="primary"
                                style={{paddingTop:0,color:"rgba(172, 168, 168, 0.26)"}}
                                disabled={true}
                                name={transaction_no}
                                id={transaction_no}
                            />
                        </TableCell>
                    )
            );
        }
        else{
            return ("")
        }
        
    }

    handleChangeCheckbox(event, status, transactionNo){
        const user=Storage.getUser()
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (value === 0) {
            const arritem = this.state.inprogressUpdateStatus.filter((data) => {
                return data.transactionNo && data.transactionNo !== transactionNo
            })
            if (arritem.length == 0) {
                this.setState({ isShowButtonUpdateStatus: false })
            }
            this.setState({ inprogressUpdateStatus: arritem })

        }

        if( value === 1) {
            let _updateStatus   = '' 

            if(status === 'BPCO' || status == "BINC"){
                _updateStatus = 'MCOM'
                this.setState({isShowButtonUpdateStatus:true})
            }
            if(status === 'MCFM'){
                _updateStatus = 'MCOM'
                this.setState({isShowButtonUpdateStatus:true})
            }

            let itemUpdateStatus ={
                transactionNo: transactionNo,
                currentStatus:status,
                updateStatus: _updateStatus,
                userId:user.userName
            }

            this.state.inprogressUpdateStatus.push(itemUpdateStatus)
            this.setState({ inprogressUpdateStatus: this.state.inprogressUpdateStatus })
        }

    }

  async  handlerUpdateStatusClick(){
        if (this.state.inprogressUpdateStatus.length > 0) {
           await this.props.handlerUpdateStatus(this.state.inprogressUpdateStatus)
            this.setState({ inprogressUpdateStatus: [], isShowButtonUpdateStatus: false })
            this.initState()
            this.setState({ taskArr: this.props.tasks })
        }
    }

    render() {
        const { filter_status_name,filter_mom_no, filter_doc_no, filter_po_contract_no, filter_po_header_text,
            filter_create_po_contract_emp_name, filter_saveBy,filter_editBy, filter_updatedate, taskArr } = this.state;
        const { page, rowsPerPage } = this.state
            console.log("taskArr ==> ",taskArr)
        return (
            <div className="sp-table-container">
                <div className="">
                    <div className="row no-gutters sp-table-content " style={{ minWidth: '900px' }}>

                        <Table className="sp-table table rrs-table" >
                            <TableHead>
                                <TableRow className="sp-table-header">
                                    {
                                        this.renderCheckbox('head')
                                    }
                                    <TableCell className="th-table text-center" style={{ width: '15px', maxWidth: '15px' }}></TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '210px', maxWidth: '210px' }}>สถานะ<br />เอกสาร</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '140px', maxWidth: '140px' }}>MOM<br />Doc No.</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '140px', maxWidth: '140px' }}>RRS<br />Doc No.</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '115px', maxWidth: '115px' }}>PO/Contract<br />No.</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '200px', maxWidth: '200px' }}>Header<br />Text</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '180px', maxWidth: '180px' }}>พนักงานจัดหาผู้รับผิดชอบ<br />PO/Contract</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '180px', maxWidth: '180px' }}>Create by</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '180px', maxWidth: '180px' }}>Edit by</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '120px', maxWidth: '100px' }}>Edit Date</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '60px', maxWidth: '60' }}>ระยะเวลาพิจารณา<br />ของ คกก.ตรวจรับพัสดุ<br />(วันทำการ)</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '60px', maxWidth: '60' }}>จำนวนวัน<br />คงเหลือ<br />(วันทำการ)</TableCell>
                                </TableRow>
                                <TableRow className="sp-table-filter">
                                    {
                                        this.renderfilter()
                                    }
                                    {/* <TableCell></TableCell> */}
                                    {/* <TableCell><input type="text" placeholder=" " name="filter_status_name"  className="form-control" onChange={this.handleChange} value={filter_status_name} /></TableCell> */}
                                    <TableCell colSpan="2">                                        
                                        <DropDownMuti
                                        loadOptions={this.statusOptions}
                                        id="MUTI_STATUS"
                                        value={this.state.MUTI_STATUSList}
                                        className="form-control"
                                        placeholder=" "
                                        onChange={this.handleDropdownMutiChange}
                                        
                                        >
                                        </DropDownMuti>
                                    </TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_mom_no"  className="form-control" onChange={this.handleChange} value={filter_mom_no} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_doc_no"  className="form-control" onChange={this.handleChange} value={filter_doc_no} /></TableCell>                                    
                                    <TableCell><input type="text" placeholder=" " name="filter_po_contract_no"  className="form-control" onChange={this.handleChange} value={filter_po_contract_no} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_po_header_text"  className="form-control" onChange={this.handleChange} value={filter_po_header_text} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_create_po_contract_emp_name"  className="form-control" onChange={this.handleChange} value={filter_create_po_contract_emp_name} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_saveBy"  className="form-control" onChange={this.handleChange} value={filter_saveBy} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_editBy"  className="form-control" onChange={this.handleChange} value={filter_editBy} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_updatedate"  className="form-control" onChange={this.handleChange} value={filter_updatedate} /></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    taskArr ? (
                                        taskArr.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((task, index) => {
                                                return (
                                                    <>
                                                    <TableRow key={"task_" + ((page * rowsPerPage) + index) + "_" +  task.transaction_no}>
                                                        
                                                        {
                                                          this.renderCheckboxMC(task.status, task.status_name, task.transaction_no)
                                                        }
                                                        <TableCell><ACollapse isExpand='N' id={"task_committee_"+index} ></ACollapse></TableCell>
                                                        <TableCell className="text-left"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.status_name}</TableCell>
                                                        <TableCell className="text-center"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.mom_no}</TableCell>
                                                        <TableCell className="text-center"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.doc_no}</TableCell>
                                                        <TableCell className="text-center" onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.po_contract_no}</TableCell>
                                                        <TableCell className="text-left"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.po_header_text}</TableCell>
                                                        <TableCell className="text-left"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.create_po_contract_emp_name}</TableCell>
                                                        <TableCell className="text-left"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.createBy_name}</TableCell>
                                                        <TableCell className="text-left"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.reviewer_name}</TableCell>
                                                        <TableCell className="text-center"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{moment(task.updatedate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell className="text-center"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}>{task.audit_committee_time_to_consider==null ? "-":task.audit_committee_time_to_consider}</TableCell>
                                                        <TableCell className="text-center"  onClick={() => { this.handlerEditClick(index, task.transaction_no,task.doc_type) }} style={{ cursor: 'pointer' }}><span className={ (task.remain_date_no2 >= 0?"":" required")  }>{task.remain_date_no2==null?"-":task.remain_date_no2}</span> </TableCell>
                                                    </TableRow>
                                                    <TableRow validity="hidden"></TableRow>                                                 
                                                    <TableRow key={"task_committee" + ((page * rowsPerPage) + index) + "_" +  task.transaction_no}>
                                                        <TableCell></TableCell>
                                                        <TableCell colSpan="12" className="text-center" style={{borderWidth:"1px" ,BorderStyle:"solid"}}>
                                                        <TableCommittee id={"task_committee_"+index} isExpand="N" t_PO_COMMITTEE = {task.t_PO_COMMITTEE} >
                                                    </TableCommittee>      
                                                     </TableCell>
                                                    </TableRow>

                                                    </>
                                                )   
                                            })) : (
                                            <TableRow key={0}>
                                                <TableCell colSpan="11" className="text-center" style={{
                                                    textAlign: 'center',
                                                    fontStyle: 'italic',
                                                    color: 'gray'
                                                }}>No data</TableCell>
                                            </TableRow>
                                        )
                                }
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            component="div"
                            count={taskArr.length}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                            }}
                            onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                        />
                    </div>
                    <div className="rrs-detail py-1" style={{overflowX:'hidden'}}>
                        <div className="row sp-table-content-footer">
                            <div className="col-12 sp-header-button-panel2">
                                {
                                    this.state.isShowButtonUpdateStatus ?
                                        <a className="sp-btn-icon" style={{width:'250px'}} onClick={() => { this.handlerUpdateStatusClick() }}>
                                            <i className="icon btn-order-publish" />
                                            <span className="sp-btn-icon-label">Update Status ( Mark Complete )</span>
                                        </a> : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//export default TaskTable
const mapStateToProps = state => {
    const { MyTaskRedux, UserRedux } = state
    return {
        resultUpdateStatus: MyTaskRedux.resultUpdateStatus,
        tasks: MyTaskRedux.myTask,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateStatus: (updateStatusArr) => dispatch(updateStatusAction(updateStatusArr)),
        getMyTask: (tabId, userId, userRole, userDepartment) => dispatch(getMyTaskAction(tabId, userId, userRole, userDepartment)),
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(TaskTable);